import { useTableSort } from '@/context/tableSortContext';
import React, { useEffect, useMemo, useRef } from 'react';
import { useSortBy } from 'react-instantsearch';

// Columns whose Typesense sort field differs from the column field.
const TYPESENSE_SORT_FIELDS = {
	// Insight ids are strings in Typesense (for search); these int copies sort numerically.
	insightId: 'insightIdSort',
	claimId: 'claimIdSort',
	// Priority as its level index, so it sorts by urgency rather than alphabetically.
	priority: 'priorityIndex',
	// The tasks "Client" column renders clientName.
	deal: 'clientName',
};

const getSortField = (field) => TYPESENSE_SORT_FIELDS[field] ?? field;

const InstantSearchSortSync = ({ indexName, columns, tab }) => {
	const { currentSort } = useTableSort();
	const lastSortRef = useRef(null);

	const sortItems = useMemo(
		() =>
			columns.reduce((acc, cell, index) => {
				if (index === 0) {
					acc.push({ value: indexName, label: cell.label });
				}
				acc.push({
					value: `${indexName}/sort/${getSortField(cell.field)}:asc`,
					label: `${cell.label} (asc)`,
				});
				acc.push({
					value: `${indexName}/sort/${getSortField(cell.field)}:desc`,
					label: `${cell.label} (desc)`,
				});
				return acc;
			}, []),
		[columns, indexName],
	);

	const { refine } = useSortBy({ items: sortItems });

	useEffect(() => {
		lastSortRef.current = null;
	}, [indexName, tab]);

	useEffect(() => {
		const nextSort =
			!currentSort?.field || !currentSort?.sort
				? indexName
				: `${indexName}/sort/${getSortField(currentSort.field)}:${currentSort.sort}`;

		if (lastSortRef.current === nextSort) {
			return;
		}

		lastSortRef.current = nextSort;
		refine(nextSort);
	}, [currentSort, indexName, refine, tab]);

	return <></>;
};

InstantSearchSortSync.displayName = 'InstantSearchSortSync';

export default InstantSearchSortSync;
